export const ASSESSMENT_SCHEMES = 'assessment-schemes'
export const ASSESSMENTS = 'assessments'
export const ACCEPTANCE_LETTER = 'acceptance-letter'
export const STUDENTS = 'students'
export const STUDENT = 'student'
export const ATTENDANCE = 'attendance'
export const OAUTH = 'oauth'
export const USERS = 'users'
export const BATCH_PLANS = 'batch-plans'
export const BATCHES = 'batches'
export const COURSES = 'courses'
export const COURSE = 'course'
export const BRANCHES = 'branches'
export const MODULES = 'modules'
export const CLASSES = 'classes'
export const EXAMS = 'exams'
export const MOODLE = 'moodle'
export const CONFIG = 'config'
export const COUNSELORS = 'counselors'
export const COUNSELLOR = 'counsellor'
export const TARGETS = 'targets'
export const DASHBOARDS = 'dashboards'
export const INTAKES = 'intakes'
export const INTAKE = 'intake'
export const LEVELS = 'levels'
export const COURSE_TRANSFER_REQUESTS = 'course-transfer-requests'
export const CUSTOM_DISCOUNT_REQUESTS = 'custom-discount-requests'
export const GENERAL_DISCOUNTS = 'general-discounts'
export const PAYMENT_SCHEMES = 'payment-schemes'
export const PAYMENT_PLAN = 'payment-plan'
export const INQUIRY = 'inquiry'
export const ENROLLED_STUDENTS = 'enrolled-students'
export const ENROLLMENT_REQUESTS = 'enrollment-requests'
export const BANK_TRANSFER = 'bank-transfer'
export const FILTER = 'filter'
export const REPEAT = 'repeat'
export const DISCOUNT = 'discount'
export const PAYMENT_PLAN_TYPES = 'payment-plan-types'
export const FOLLOW_UPS = 'follow-ups'
export const FOLLOWUP = 'followup'
export const REQUEST = 'request'
export const MODULE = 'module'
export const ASSESSMENT_DATES = 'assessment-dates'
export const UNASSIGNED = 'unassigned'
export const PENDING_PAYMENT = 'pending-payment'
export const COLLECT_PAYMENT = 'collect-payment'
export const DAILY_TRANSACTIONS = 'daily-transactions'
export const ASSESSMENT_TIME_TABLE = 'assessment-time-table'
export const TOKEN = 'token'
export const PASSWORD = 'password'
export const SEMESTERS = 'semesters'
export const CHANGE_STUDENT_CLASS = 'change-student-class'
export const GROUP_STUDENTS = 'group-students'
export const SLOTS = 'slots'
export const CODES = 'codes'
export const STATS = 'stats'
export const CALENDAR = 'calendar'
export const COURSE_LEVEL_MODULES = 'course-level-modules'
export const PAYMENT_PLANS = 'payment-plans'
export const RESULTS = 'results'
export const EXPORT = 'export'
export const STATUS = 'status'
export const GAP = 'gap'
export const TIMELINE = 'timeline'
export const HAA = 'haa'
export const HOLIDAYS = 'holidays'
export const HEAD_OF_SCHOOL = 'headOfSchool'
export const UPCOMING_CLASSES = 'upcoming-classes'
export const GENERAL = 'general'
export const UPLOAD_FILE = 'upload-file'
export const FURTHER_INFO = 'further-info'
export const CONTACT = 'contact'
export const EMPLOYMENT = 'employment'
export const QUALIFICATIONS = 'qualifications'
export const CUSTOM_DISCOUNT = 'custom-discount'
export const PAYMENT_PLAN_DETAILS = 'payment-plan-details'
export const OFFER_LETTER = 'offer-letter'
export const HOS_APPROVAL_REQUEST = 'hos-approval-request'
export const HAA_APPROVAL_REQUEST = 'haa-approval-request'
export const REMARK = 'remark'
export const TEMP_CLASSES = 'temp-classes'
export const EXEMPTIONS = 'exemptions'
export const LEVEL_PAYMENT_PLAN = 'level-payment-plan'
export const EXEMPTION = 'exemption'
export const FEE_DETAILS = 'fee-details'
export const EXEMPTION_FEE_DETAILS = 'exemption-fee-details'
export const MY = 'my'
export const INQUIRY_CB_NUMBER = 'inquiry-cb-number'
export const ITADMIN = 'itAdmin'
export const LEAVE_REQUESTS = 'leave-requests'
export const LECTURERS = 'lecturers'
export const LECTURER = 'lecturer'
export const STUDENT_MARKING = 'student-marking'
export const LEVEL = 'level'
export const PAYMENT_GATEWAY = 'payment-gateway'
export const PAYMENT_STRUCTURE = 'payment-structure'
export const ACTIVATE = 'activate'
export const BY_LEVEL_SCHEME = 'by-level-scheme'
export const SPECIAL_APPROVAL = 'special-approval'
export const TYPES = 'types'
export const SCHEMAS = 'schemas'
export const CHECK = 'check'
export const SCHOOLS = 'schools'
export const REGISTERED = 'registered'
export const REMARKS = 'remarks'
export const PARENTS = 'parents'
export const PROGRESSION = 'progression'
export const REQUESTS = 'requests'
export const APPROVAL = 'approval'
export const DROP = 'drop'
export const STUDENT_PROJECTS = 'student-projects'
export const LOGS = 'logs'
export const IMPORT = 'import'
export const INVOICES = 'invoices'
export const INITIALIZE = 'initialize'
export const NOTIFICATION = 'notification'
export const FINANCE = 'finance'
export const BATCH = 'batch'
export const SEND_TO_ACADEMIC_ADMIN = 'send-to-academic-admin'